function isScrolledIntoView(elem) {

    var $elem = $(elem);
    var $window = $(window);
    if ($elem.offset() != undefined)
    {
        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();
        //console.log($elem.offset());
        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();
        return (((elemBottom - 750) <= (docViewBottom)));
    }

}

function ChangeHashedStringParamValue(params, removedParam, newValue) {


    if (params != undefined && params.length > 0) {

        var splitStr = (removedParam + "=");
        var newParamsArray = params.split(splitStr);

        if (newParamsArray.length >= 2) {
            var firstPartOfParams = newParamsArray[0];
            var secondPartOfParams = "";
            var beginCalc = false;
            for (var i = 0; i < newParamsArray[1].length; i++) {

                if (beginCalc) {
                    secondPartOfParams += newParamsArray[1][i];
                }

                if (newParamsArray[1][i] == "&") {
                    beginCalc = true;
                }


            }

            params = firstPartOfParams + removedParam + "=" + newValue + "&" + secondPartOfParams;

        }

    }

    return params;

}

function GetQuickLookEvents() {
    $("#QuickLookModal .SmallProductImages img").live("click", function () {
        var ImageIndex = $(this).index();
        $("#QuickLookModal .ProductDetailImages ul li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).removeClass("gizli");
                $(this).find("a img").attr("src", $(this).find("a img").data("src"));
            }
            else {
                $(this).addClass("gizli");
            }

            
        });
        $("#QuickLookModal .SmallProductImages img").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("Selected");
            } else {
                $(this).removeClass("Selected");
            }


        });


    });

}

function LeftMenuFixedOptions() {
    $(window).scroll(function () {
        // console.log($(window).scrollTop() + ($(window).height() - 10) +"----"+ $(document).height())
        var TopValue = $("footer").height();

        if ($(window).scrollTop() + ($(window).height() + 300) > $(document).height()) {
            $(".CategoryLeftBar").css("top", "-" + (TopValue) + "px");

        } else {

            $(".CategoryLeftBar").css("top", "inherit");
        }
    });
}

function GetLeftCatalogList() {

    $curCatalog = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");

    if ($curCatalog.length > 0) {
        $curUL = $curCatalog.closest(".itemsWrapper").closest("li").first().clone();

        if ($curUL.length < 1) {
            $curUL = $curCatalog.closest("li").first().clone();
        } else {

        }

        $(".SubCatNavs").html("");
        $(".SubCatNavs").append($curUL);

        $selectedCats = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");
        $selectedCats2 = $("#SubCatNavs a[data-rel='" + $("#PID").val() + "']");
        var triangle = $("<span class='triangle'></span>")
        var img = $("<img class='kingIcon' src='/Images/HSP/Icons/king_white.png'/>")
        $selectedCats2.prepend(img);
        $selectedCats2.append(triangle);
        $selectedCats2.css("font-weight", "bold");

        $("#SubCatNavs>li").prepend("<span class='toggleIcon'></span>");
        //$selectedCats2.css("color", "#797979");
        $selectedCats2.addClass("king");
        if ($selectedCats2.parent().parent().parent().hasClass("ListWrapper")) {
            $selectedCats2.parent().addClass("opened");
        } else {
            $selectedCats2.parent().closest("div").parent().addClass("opened");
        }

    }

    $(".SubCatNavs>li .itemsWrapper .ListWrapper>ul>").each(function () {

        if ($(this).find("div").length == 0) {
            $(this).addClass("hidePlusIcon");
        }
    });

    FixedLeftBar();
    //LeftMenuFixedOptions();
}

function FixedLeftBar() {
    $(window).scroll(function () {
        if ($(".contentTopSpace > div").height() > 689 ) {
            if ($("body").hasClass("Scrolled")) {
                if ($(window).width() > 767) {
                    $("#LeftWrapper").addClass("FixedLeftBar");
                }
               
            } else {
                $("#LeftWrapper").removeClass("FixedLeftBar");
            }
        }


        
    });
}

function ToggleLeftBarItems() {
    if ($(window).width() > 767) {
        $(".itemsWrapper > .ListWrapper > ul > li").live("click", function () {
            $(".itemsWrapper  .ListWrapper  ul  li").not(this).removeClass("opened");
            $(this).toggleClass("opened");
        });
    }


}

function ToggleLeftBar() {
    $(".FilterForm .filterLink").live("click", function () {
   
        if (!$(this).parent().find(".FilterBoxes").is(":visible")) {
            $(".FilterBoxes").slideUp();
            $(this).parent().find(".FilterBoxes").slideToggle();
            $(this).toggleClass("toggle-minus");
        }
        else {
            $(this).parent().find(".FilterBoxes").slideToggle();
            $(this).toggleClass("toggle-minus");
        }
 
        
    });

    $(".SubCatNavs > li > .toggleIcon").live("click", function (e) {
        $(this).parent().find(".itemsWrapper").slideToggle();
        $(this).toggleClass("toggle-minus");
        e.preventDefault;
        return false;
    });

}


function GetHappyShopCardPriceForQuickLook() {

    var Amount2 = $("#ForMemberCardAmount2").val();
    var OldAmount2 = $("#ForMemberCardOldAmount2").val();
    var MemberCardGroupID2 = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode2 = $("#ForMemberCardCurrencyCode2").val();
    //console.log(Amount2 +"--"+ OldAmount2 +"--"+ MemberCardGroupID2 +"--"+ ForMemberCardCurrencyCode2);
    if (Amount2 != undefined && OldAmount2 != undefined && MemberCardGroupID2 != undefined && ForMemberCardCurrencyCode2 != undefined && MemberCardGroupID2 != -1) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount2 + "&AmountOld=" + OldAmount2 + "&MemberCardGroupID=" + MemberCardGroupID2,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {
                    $("#QuickLookModal .RPrice").html(dt.TotalAmount + " " + ForMemberCardCurrencyCode2);
                    $("#QuickLookModal .HappyShopCardPrice").css("display", "inline-block");
                    //console.log(dt);
                }

            }
        });
    }

}


function SetFixedLeftBarHeigt() {

    var windowHeight = ($(window).height()-180);
    if($(window).width() > 991){
         $("#LeftWrapper").height(windowHeight);
    }

   
}



function AddProductInformationToDataLayer(id, name, category, brand, variant, position) {

    var productListFromUrl = window.location.pathname;
    var listNew = "";

    if (productListFromUrl != undefined && productListFromUrl != null) {
        listNew = productListFromUrl.substring(1, productListFromUrl.length - 1);
    }

    productCategory = listNew;

    var clicked_product = {
        'id': id,
        'name': name,
        'category': category,
        'brand': brand,
        'variant': variant,
        'position': position
    };

    ga('ec:addProduct', 
        clicked_product
    );
    ga('ec:setAction', 'click', { list: 'Search Results' });

    ga('send', 'event', 'UX', 'click', 'Results', {
        hitCallback: function () {
            //document.location = '/product_details?id=P12345';
        }
    });
}

var isNewRequestAllowed = true;
var isFirstLoad = false;
var LoadPage = 1;

$(document).ready(function () {




    var IsAutoScrollOpen = Boolean($("#AutoScroll").val());

    if (IsAutoScrollOpen) {

        $(".Pages").hide();
    }

    function GetHashParamValue(param) {

        if (window.location.hash.indexOf("&" + param + "=") == -1) {
            return "";
        }

        var nmVL = window.location.hash.split("&" + param + "=");
        return nmVL[1].split("&")[0];

    }

    GetQuickLookEvents();
    GetLeftCatalogList();
    ToggleLeftBarItems();
    ToggleLeftBar();
    SetFixedLeftBarHeigt();


    $(window).on("resize", function () {
        SetFixedLeftBarHeigt();
    });

    var ScrollContentID = "LastScrollTop" + $("#PID").val();
    var LastScrollTop = $.cookie(ScrollContentID);

    if (window.location.hash != undefined && window.location.hash.length > 0) {

        isFirstLoad = true;
        LoadPage = Number(GetHashParamValue("p"));
    }


    var grd = GetHashParamValue("g");


    if ($(window).width() < 767 && grd != undefined && grd == "") {


        $("#GridIcons input, #GridIcons label").removeAttr("checked");
        $("#GridIcons input, #GridIcons label").removeClass("checked");
        $("#GridIcons input, #GridIcons label").removeClass("c_on");

        var $checked = $("#GridIcons input[value='6']");
        $checked.closest("li.gr").find("label").addClass("c_on checked");

        $checked.prop("checked", true);
    }

    $(".ProductList > .Prd > .PrdInner a").live("click", function () {

        var ProductID = $(this).attr("data-product");
        //var Position = $(this).attr("data-position");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cat/GetClickedProductDataLayerInformation",
            data: "productID=" + ProductID,
            dataType: 'json',
            async: true,
            cache: false,
            success: function (dt) {
                AddProductInformationToDataLayer
                (
                    dt.id,
                    dt.name,
                    dt.category,
                    dt.brand,
                    dt.variant,
                    dt.position
                );
            }
        });
    });



    $(window).bind('hashchange', function (e) {

        var hs = window.location.hash;

        var params = hs.replace("#", "");

        if (hs == "#_=_") {

            window.location.hash = "";
            document.location.href = "";
        }

        if ($("form#FilterForm").length > 0 && $("#sr").length == 0 && $("#Tag").length == 0 || $("#CombineList").length > 0) {


            $gizlenecekSecim = $(".Products");
            //$gizlenecekSecim.css("opacity", "0.1");
            $(".AjaxLoader").show();

            var nmVL = params.split("&");

            for (var i = 0; i < nmVL.length; i++) {


                var nmVL2 = nmVL[i].split("=");


                for (var j = 0; j < nmVL2.length; j++) {


                    if (nmVL2[0] == "u") {

                        $("select#u option").removeAttr("selected");
                        $("select#u option[value='" + nmVL2[1] + "']").prop("selected", true);


                        $("#PrdItemNo input, #PrdItemNo label").removeAttr("checked");
                        $("#PrdItemNo input, #PrdItemNo label").removeClass("checked");
                        $("#PrdItemNo input, #PrdItemNo label").removeClass("c_on");

                        var $checked = $("#PrdItemNo input[value='" + nmVL2[1] + "']");
                        $checked.prop("checked", true);

                        $checked.parent().find("label").addClass("checked");
                        $checked.parent().find("label").addClass("c_on");
                        $(".FlinkItemCount").text($checked.parent().find("label").text());
                    }

                    if (nmVL2[0] == "o") {

                        $("#PrdSort input, #PrdSort label").removeAttr("checked");
                        $("#PrdSort input, #PrdSort label").removeClass("checked");
                        $("#PrdSort input, #PrdSort label").removeClass("c_on");

                        var $checked = $("#PrdSort input[value='" + nmVL2[1] + "']");
                        $checked.prop("checked", true);

                        $checked.parent().find("label").addClass("checked");
                        $checked.parent().find("label").addClass("c_on");
                        //$(".fLinkSortNo").html($checked.parent().find("label").text() + "<div class='plus-Icon'></div>");

                    }


                    if (nmVL2[0] == "g") {

                        $("#GridIcons input, #GridIcons label").removeAttr("checked");
                        $("#GridIcons input, #GridIcons label").removeClass("checked");
                        $("#GridIcons input, #GridIcons label").removeClass("c_on");

                        var $checked = $("#GridIcons input[value='" + nmVL2[1] + "']");
                        $checked.prop("checked", true);

                        $checked.parent().find("label").addClass("checked");
                        $checked.parent().find("label").addClass("c_on");

                    }

                    var filterSelector = "none";
                    if (nmVL2[0] == "sc") filterSelector = "sc";
                    if (nmVL2[0] == "c") filterSelector = "cl";
                    if (nmVL2[0] == "b") filterSelector = "mr";
                    if (nmVL2[0] == "sty") filterSelector = "sty";
                    if (nmVL2[0] == "s") filterSelector = "sz";

                    if (nmVL2[0] == "prc") {

                        $("input#prc").attr("data-slider-value", "[" + nmVL2[1] + "]");
                        var vlDefault = $("input#prc").attr("data-slider-value").replace("[", "").replace("]", "").split("-");
                        $("input#prc").attr("value", vlDefault[0] + '-' + vlDefault[1]);

                        //$("input#prc").val(nmVL2[1].split('-')[1]); 

                    }

                    if (filterSelector != "none") {

                        $(".fil" + filterSelector + " label").removeAttr("checked");
                        $(".fil" + filterSelector + "  input").removeClass("checked");
                        $(".fil" + filterSelector + "  label").removeClass("c_on");


                        var ParamValues = nmVL2[1].split(",");

                        for (var q = 0; q < ParamValues.length; q++) {

                            var $checked = $(".fil" + filterSelector + " input[value='" + ParamValues[q] + "']");
                            $checked.prop("checked", true);

                            $checked.parent().find("label").addClass("checked");
                            $checked.parent().find("label").addClass("c_on");

                            $(".fil" + filterSelector).closest("div").find(".RemoveFilter").show();

                        }




                    }


                }


            }

            //var NewGrid = GetHashParamValue("g");

            if (params == undefined || params == null || params == "") {

                existParams = compress($("form#FilterForm").serialize());
                params = existParams.replace("#", "");


            }

            if (params != undefined && params != null) {

                $(".AjaxLoader").show();
                isNewRequestAllowed = false;

                var defAdress = "/Home/GetProductList";

                if ($("#CombineList").length > 0) {
                    defAdress = "/Cat/Combines";
                }

                //calculate all loaded pages till current page
                if (isFirstLoad && LoadPage > 1) {
                    var uParam = GetHashParamValue("u");
                    if (uParam == undefined || uParam == "") {
                        uParam = 1;
                    }
                    else {
                        uParam = Number(uParam);
                    }

                    var newUParam = LoadPage * uParam;

                    params = ChangeHashedStringParamValue(params, "u", newUParam);
                    params = ChangeHashedStringParamValue(params, "p", 1);


                }
                var lastindex = 0;



                $.ajax({
                    type: "GET",
                    url: "/" + $("#SmallLangCode").val() + "/p" + defAdress,
                    data: params,
                    cache: false,
                    success: function (data) {

                        //$gizlenecekSecim.animate({
                        //    opacity: 1
                        //}, 500, function () {

                        //});

                        $(".AjaxLoader").hide();

                        isNewRequestAllowed = true;

                        //console.log("IsAutoScrollOpen:" + IsAutoScrollOpen, " isFirstLoad:" + isFirstLoad + " combinelen" + $("#CombineList").length);

                        if (IsAutoScrollOpen && !isFirstLoad) {

                            if ($(".ProductList .NotFound").length <= 0) {

                                console.info($("#GridIcons li label.checked").parent().find("input").val())

                               if($("#GridIcons li label.checked").parent().find("input").val() == 3){
                                   $(".ProductColumn").removeClass("col-md-16");
                                   $(".ProductColumn").addClass("col-md-19");
                               } else {
                                   $(".ProductColumn").removeClass("col-md-19");
                                   $(".ProductColumn").addClass("col-md-16");
                               }

                                $(".Products").append(data);
                                //$(".FilterForm .FilterBoxes").hide();

                            }

                            $(".Pages:first").html($(".Products .Pages:eq(2)").html());

                            $(".Products .Pages:gt(0)").remove();

                            if (IsAutoScrollOpen && $("#CombineList").length <= 0) {

                                $(".Pages").hide();
                            }

                            isFirstLoad = false;

                            lastindex = $(".Products .ProductList").length;

                            if (UseTagManager && lastindex != undefined) {

                                //console.log("lastindex" + lastindex);

                                AddFilterEvent(),
                                AddImpression('');
                                SendGaDataLayerVirtual();
                            }


                        }
                        else {

                            if ($("#GridIcons li label.checked").parent().find("input").val() == 3) {
                                $(".ProductColumn").removeClass("col-md-16");
                                $(".ProductColumn").addClass("col-md-19");
                            } else {
                                $(".ProductColumn").removeClass("col-md-19");
                                $(".ProductColumn").addClass("col-md-16");
                            }

                            $(".Products").html(data);

                            isFirstLoad = false;

                            if (LastScrollTop != undefined && LastScrollTop.length > 0) {
                                LastScrollTop = Number(LastScrollTop);

                                $('html, body').animate({
                                    scrollTop: LastScrollTop
                                }, 500);

                                $.cookie(ScrollContentID, null, { expires: -1 });

                            }
                        }

                        //

                        if ($(".CatBannerContainer").length > 0 && $(".backdrop").length > 0) {

                            $(".PrdContainer .ProductList .Prd").addClass("col-sm-12");

                            if ($("#GridIcons .gr input:checked:first").val() != "4") {
                                $(".PrdContainer .ProductList .Prd").removeClass("col-xs-24").addClass("col-xs-12");
                            }
                            else {
                                $(".PrdContainer .ProductList .Prd").removeClass("col-xs-12").addClass("col-xs-24");
                            }
                        }


                    }

                });



            }

        }

    });


    var finished = false;


    $('#ColorFilters > li.colorfilter a').click(function (event) {

        //alert("aa");
        $li = $(this).closest("li");

        if ($li.find("input:checked").length > 0) {

            $li.find("input").removeAttr("checked");
            $li.removeClass("selected");

        }
        else {

            $li.find("input").attr("checked", "checked");
            $li.addClass("selected");

        }

        $li.find("input").trigger("change");

    });

    $(".RemoveFilter").live("click", function () {

        $filterContainers = $(this).closest("div");

        if ($filterContainers.find("input:checked").length > 0) {

            $filterContainers.find("input").removeAttr("checked");
            $filterContainers.find("label").removeClass("checked");
            $filterContainers.find("label").removeClass("c_on");

        }

        $filterContainers.find("ul > li > input").trigger("change");

    });

    $('#ColorFilters > li input, #Styles > li input,#Departments > li input, #Sizes > li input, #PrdSort > li input,  #Molds > li input, #PrdItemNo > li input, #GridIcons > li.gr input').live("change", function (e) {

        //alert("color");

        $curIput = $(this);
        $curLi = $(this).closest("li");
        $curLabel = $curLi.find("label:first");
        //console.log("curlabel :" + $curLabel.html());

        if ($(this).hasClass("RemoveFilter")) {

            $filtercontainer = $(this).closest("div");

            if ($filtercontainer.find("input:checked").length > 0) {

                $filtercontainer.find("input").removeAttr("checked");
                $filtercontainer.find("label").removeClass("checked");
                $filtercontainer.find("label").removeClass("c_on");

            }

            //$(this).hide();
        }

        var GridVal = "";
        var SortVal = "";
        var ItemOnPage = "&u=" + $("#GridIcons #u").val();

        if ($(this).closest("#GridIcons").length > 0) {

            $("#GridIcons input").removeAttr("checked");
            $("#GridIcons label").removeClass("checked");
            $("#GridIcons label").removeClass("c_on");

            if ($curIput.val() == '6' && $("#u option:selected").val() == '16') {

                $("select#u option").removeAttr("selected");
                $("select#u option[value='24']").prop("selected", true);
                $("select#u").parent().find("span.select").html("24");
            }

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on");

            GridVal = "&g=" + $curIput.val();

            if (IsAutoScrollOpen && GridVal != grd) {

                $(".Products").html("");
                grd = GridVal;
            }


        }

        if ($(this).closest("#PrdSort").length > 0) {

            SortVal = "&o=" + $curIput.val();

            $("#PrdSort input").removeAttr("checked");
            $("#PrdSort label").removeClass("checked");
            $("#PrdSort label").removeClass("c_on");

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on");

            //$("#PrdSort").parent().hide();

            if ($(this).closest(".FilterSortBy").length > 0) {
                //$(this).closest("#PrdSort").parent().hide();
                //$(this).closest(".FilterSortBy").find(".filterLink").text($(this).find("label:first").text());
            }

            //$(".fLinkSortNo").text($("label", $(this)).text());

            if (IsAutoScrollOpen) {
                $(".Products").html("");
            }
        }

        if ($(this).closest("#Sizes").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }


        if ($(this).closest("#Styles").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }

        if ($(this).closest("#Departments").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }

        if ($(this).closest("#Molds").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
            }
        }



        if ($(this).closest(".filcl").length > 0) {

            if (IsAutoScrollOpen) {

                $(".Products").html("");
                //console.log("filcl exists clearing products");

            }
        }

        if ($(this).closest("#PrdItemNo").length > 0) {

            SortVal = "&u=" + $("input", $(this)).val();

            $("#PrdItemNo input").removeAttr("checked");
            $("#PrdItemNo label").removeClass("checked");
            $("#PrdItemNo label").removeClass("c_on");

            $curIput.attr("checked", "checked");
            $curLabel.addClass("c_on checked");

            $("#PrdItemNo").parent().hide();


            $(this).closest("#PrdItemNo").parent().hide();
            $(".FlinkItemCount").text($("input", $(this)).val());

            if (IsAutoScrollOpen) {
                $(".Products").html("");
            }

        }

        //var $li = $(this);
        // console.log("li:" + $curLi.html());


        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        if ($curLi.find("input:first").is(':checked')) {

            // console.log("li input checked");

            $curLi.find("input").attr("checked", "checked");
            $curLi.find("label:first").addClass("c_on");

        }
        else {

            //console.log("li input not checked");

            $curLi.find("input").removeAttr("checked");
            $curLi.find("label").removeClass("checked");
            $curLi.find("label").removeClass("c_on");

        }

        //if ( !e.target.nodeName == "INPUT") {

        window.location.hash = compress($(this).closest("form").serialize());

        //e.preventDefault();
        //return;
        //}




    });

   


    //$("#ColorFilters > li > label, #ColorFilters > li input").live("click", function (e)
    //{
    //   // console.log("LABEL OR PNIT CLICKED");
    //    e.preventDefault();
    //    return;

    //});

    var a = window.location.hash;

    if ($("form#FilterForm").length > 0 && a == "" && $("#sr").length == 0 && $("#Tag").length == 0) {

        var pgNo = "1";

        if ($('.Pages a.selected').length > 0) {

            pgNo = $('.Pages a.selected:first').attr("data-pgno");
        }


        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        if (IsAutoScrollOpen) {

            var paramPgNo = GetHashParamValue("p");

            if (paramPgNo != undefined && paramPgNo.length > 0) {
                pgNo = pgNo;
            }

        }

        if (pgNo != "1" && (document.URL.indexOf("page=").length <= 0 || window.location.hash.length > 0)) {
            window.location.hash = compress($("form#FilterForm").closest("form").serialize() + "&p=" + pgNo);
        }

    } else if ($("form#FilterForm").length > 0 && a != "") {

        //change params on refresh
        var paramF = GetHashParamValue("f");

        if (paramF == "") {
            paramF = "&f=1";
        }
        else {
            paramF = "&f=" + (Number(paramF) + 1);
        }

        var curHash = a.split("&f=")[0] + paramF;


        window.location.hash = curHash;
    }

    $('.Pages a').live("click", function (e) {

        $curPage = $(this);

        if (IsAutoScrollOpen) {

            //$nextPage = $('.Pages a.selected').next(); 
            //$('.Pages a').removeClass("selected");
            //$nextPage.addClass("selected");


        } else {

            $('html, body').animate({
                scrollTop: $("div.row.Products").offset().top + -90
            }, 500);

        }

        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }


        if ($("#CombineList").length > 0) {

            window.location.hash = "p=" + $curPage.attr("data-pgno");

        }
        else {

            pgNo = $curPage.attr("data-pgno");

            if (IsAutoScrollOpen) {

                var paramPgNo = GetHashParamValue("p");

                if (paramPgNo != undefined && paramPgNo.length > 0) {
                    pgNo = Number(paramPgNo) + 1;
                }
            }

            window.location.hash = compress($("form#FilterForm").serialize()) + "&p=" + pgNo;

        }

        e.preventDefault;
        return false;

    });


    $('#GridIcons #u').live("change", function () {

        if (IsAutoScrollOpen == false) {
            $('html, body').animate({
                scrollTop: $("div.row.Products").offset().top
            }, 500);
        }


        if ($("input#prc").length > 0) {
            $("input#prc").val($("input#prc").val().replace(",", "-"));
        }

        $curPage(".Pages a.selected");

        pgNo = $curPage.attr("data-pgno");

        if (IsAutoScrollOpen) {

            var paramPgNo = GetHashParamValue("p");

            if (paramPgNo != undefined && paramPgNo.length > 0) {
                pgNo = Number(paramPgNo);
            }

        }

        window.location.hash = compress($("form#FilterForm").serialize()) + "&p=" + pgNo;
    });


    //$(".filterLink").on("click", function () {

    //    $(".FilterBoxes").not($(this).next(".FilterBoxes")).hide();
    //    $(this).next(".FilterBoxes").toggle();


    //    if ($(this).closest(".FilterSortBy").length > 0) {
    //        $(this).next(".FilterBoxes").toggle();
    //    }

    //});

    //$(".filterLink").live("click",function (e) {

    //    $(".FilterBoxes").not($(this).next(".FilterBoxes")).slideUp("fast");
    //    $(this).next(".FilterBoxes").slideToggle("fast");


    //    if ($(this).closest(".FilterSortBy").length > 0) {
    //        $(this).next(".FilterBoxes").toggle("fast");
    //    }

    //});

    var hs1 = window.location.hash;

    if ($("form#FilterForm").length <= 0 && location.href.indexOf("ct=") != -1) {

        if (hs1 == "#_=_") {

            window.location.hash = "";
            document.location.href = "";
        }

        hs1 = hs1.replace("#", "");


        if ($("#" + hs1 + "").length > 0) {


            $("#ContactMap, #ContactInfo, #ContactForm").hide();

            $("#" + hs1 + "").show("slow");


        }
    }


    //$('.ToogleFilters').on('click', function (e, index) {

    //    $(".FilterForm").toggleClass("ShowFilters");
    //    $(this).toggleClass("active");

    //});

    $("section.FilterOption ul>li>input[type=checkbox]").live("change", function () {

        if ($(this).is(':checked')) {
            $(this).next("label").addClass("checked");
        }
        else {
            $(this).next("label").removeClass("checked");
        }
    });

    if ($("ul#ColorFilters>li>label").exists) {

        $("ul#ColorFilters>li>label.Colored").each(function () {
            var c = $(this).css("background-color");
            var xColor = [];
            if (c.length <= 7) {
                xColor = [hexToRgb(c).r, hexToRgb(c).g, hexToRgb(c).b];
            }
            else {
                xColor = c.replace(/^(rgb|rgba)\(/, '').replace(/\)$/, '').replace(/\s/g, '').split(',');
            }

            $(this).css("color", RenkKontrol(xColor) ? "white" : "black");
        });
    }


    if ($("input#prc").length > 0) {



        var vlDefault = $("input#prc").attr("data-slider-value").replace("[", "").replace("]", "").split(",");

        $("input#prc").attr("value", vlDefault[0] + '-' + vlDefault[1]);


        $("#prc").slider({
            //formater: function (value) {
            //    return '<span class="TL">' + $(".TL").first().html() + ' </span>' + value;
            //}
        });

        $("#prc").slider().on('slideStop', function (ev) {

            var vl = $("input#prc").val().split(",");

            $("input#prc").attr("value", vl[0] + '-' + vl[1]);
            $("input#prc").attr("value", $("input#prc").attr("value").replace("-undefined", ""));

            if ($(".CurMinPrice").length > 0) {

                var curCode = $(".CurValues").data("code");

                $(".CurMinPrice").text(vl[0] + " " + curCode);
                $(".CurMaxPrice").text(vl[1] + " " + curCode);
            }

            window.location.hash = compress($("form#FilterForm").serialize());

            if (IsAutoScrollOpen == false) {


                if ($("div.row-fluid.Products").length > 0) {
                    $('html, body').animate({
                        scrollTop: $("div.row-fluid.Products").offset().top + -130
                    }, 500);

                }
                else if ($("div.row.Products").length > 0) {
                    $('html, body').animate({
                        scrollTop: $("div.row.Products").offset().top + -130
                    }, 500);
                }

            }
            else {
                $(".Products").html("");
            }



        });

        $(".FilterOption .slider-horizontal").removeAttr("style");
        $(".FilterOption .slider-horizontal").width("");

        $("input#prc").hide();
    }

    //if ($("input#prc").length > 0) {

    //    $("#prc").slider({
    //        formater: function (value) {
    //            return '<span class="TL">' + $(".TL").first().html() + ' </span>' + value;
    //        }
    //    });

    //}


    $('.CatShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.CatShowLess').show();
        $('.CatSecondPart').show();
    });



    $('.CatShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.CatShowMore').show();
        $('.CatSecondPart').hide();

    });


    if ($(".CatBannerContainer").length > 0 && $(".backdrop").length > 0) {

        $(".PrdContainer .ProductList .Prd").addClass("col-sm-12");
        $(".PrdContainer .ProductList .Prd").addClass("col-xs-12");

    }


    $curCatalog = $("#MainMenu a[data-rel='" + $("#PID").val() + "']");

    //if ($curCatalog.length > 0) {
    //    $curUL = $curCatalog.closest("li").find("ul").first().clone();

    //    $(".SubCatNavs").html("");
    //    $(".SubCatNavs").append($curUL);

    //    $(".WithSub .SubCatNavs ul li:gt(6)").remove();
    //}

    $("#QuickLookModal .ProductSuggestHeader").live("click", function (e) {

        $("#QuickLookModal .Productsuggest").toggle();
        $("#QuickLookModal .CombineInfoPd").toggle();

    });

    $(".QuickLookBtn").live("click", function (e) {


        var ProductID = $(this).data("productid");
        var ColorID = $(this).data("colorid");

        $Modal = $("div#QuickLookModal");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
            data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
            success: function (dt) {

                $("div#QuickLookModal .modal-body").html(dt);
                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");


            }
        });


        $Modal.modal("show");

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swParams = GetSwPageParams();

            swParams = ChangeSwHashedStringParamValue(swParams, "ActionType", "UrunGoruntuleme");

            swParams = AddSwParam(swParams, "ProductID", ProductID);
            swParams = AddSwParam(swParams, "ColorID", ColorID);

            swParams = AddSwParam(swParams, "SubActionType", "HizliBakis");

            //console.log(swParams);

            AddSwAction(swParams);

        }

        return false;
        e.preventDefault();


    });

    $('#QuickLookModal').on('shown.bs.modal', function () {
        GetHappyShopCardPriceForQuickLook();
    });

    $('.ToogleFilters').on('click', function (e, index) {

        $("#FilterForm").slideToggle(); //toggleClass("ShowFilters");
        //$(this).toggleClass("active");

    });

    $(window).scroll(function () {

        var scroltoview = isScrolledIntoView($(".Products"));

        if (scroltoview && isNewRequestAllowed) {

            $nextPg = $(".Pages:first a.selected:first").next("a");

            if ($nextPg.length > 0 && $(".ProductList .NotFound").length <= 0) {

                $nextPg.trigger("click");

            } else {

                $("#CatalogEnded").show();
                $(".ProductList .NotFound").hide();
            }
        }


    });

});



function GetQuickLookModal(ProductID, ColorID) {

    $Modal = $("div#QuickLookModal");

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/QuickLook",
        data: 'ProductID=' + ProductID + "&ColorID=" + ColorID,
        success: function (dt) {

            $("div#QuickLookModal .modal-body").html(dt);
            $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");


        }
    });

    $Modal.modal("show");
    return false;
    e.preventDefault();

}